import { ReactElement } from 'react';

import GuideRow from '@/components/app/programV2/ProgramInfo/GuideList/GuideRow';
import { GuideRowProps } from '@/components/app/programV2/ProgramInfo/GuideList/GuideRow/types';
import MasterclassGuideRow from '@/components/app/programV2/ProgramInfo/GuideList/MasterclassGuideRow';
import Loader from '@/components/Loader';
import { useProgramInfo } from '@/hooks/app/useProgramInfo';
import useProgramStats from '@/hooks/app/useProgramStats';
import { MeditationType } from '@/store/program/types';

import { Wrapper } from './styles';
import { GuideListProps } from './types';

const GuideRowComponent = ({ guide, program, programProgress }: GuideRowProps): ReactElement => {
	if (program.meditation_type === MeditationType.MasterClass) {
		return <MasterclassGuideRow guide={guide} program={program} />;
	}

	return <GuideRow guide={guide} program={program} programProgress={programProgress} />;
};

const GuideList = ({ program }: GuideListProps) => {
	const { guides } = useProgramInfo();
	const { data: programProgress, isValidating: isLoading } = useProgramStats(program);

	if (!guides) {
		return null;
	}

	if (isLoading) {
		return <Loader />;
	}

	return (
		<Wrapper>
			{guides.map(guide => (
				<GuideRowComponent
					key={guide.id}
					guide={guide}
					program={program}
					programProgress={programProgress ?? 0}
				/>
			))}
		</Wrapper>
	);
};

export default GuideList;
